module.exports = __webpack_public_path__ + "static/media/pdmlogo2.691fe61e.png";